<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <div class="header" :class="classBool=='Index'?'opc':''">
      <div class="container">
        <h1 class="logo">
          <router-link to="/" tag="span">
            <img
              src="./assets/images/newlogo2.png"
              style="margin-top:5px; width:130px;height:42px"
              v-if="classBool=='Index'"
              alt
            />
            <img
              src="./assets/images/logo2x.png"
              style="width:130px;height:42px;margin-top:5px"
              v-else
              alt
            />
          </router-link>
        </h1>
        <ul class="nav" :class="classBool==='Index'?'ys':'nav2'">
          <router-link tag="li" to="/">首页</router-link>
          <router-link tag="li" to="/about">关于路客</router-link>
          <router-link tag="li" to="/core">产品中心</router-link>
        </ul>
      </div>
    </div>
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->

    <div class="footBots">
      <div class="footContainer">
        <div class="footWrapper">
          <div class="footWrpLeft">
            <div class="fotT">
              <span>关于路客</span>
              <span class="line"></span>
              <span>产品中心</span>
            </div>
            <div class="fotB">
              <span>联系邮箱：service@lookerstation.com</span>
              <span>联系地址：北京市海淀区上地十街1号院6号楼3层34409</span>
            </div>
          </div>
          <div class="footWrpRight" style="display:none">
            <div class="pic"></div>
            <div style="font-size:10px">
              <div class="wx"></div>
              <p style="padding-top:3px;color:white">路客驿站微信公众号</p>
            </div>
          </div>
        </div>
        <div class="footLast">京ICP备17049498号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      classBool: "Index"
    };
  },
  created() {
    // this.$nextTick(() => {
    if (localStorage.datas) {
      // console.log("有这个存储")
      console.log(localStorage.datas);
      this.classBool = localStorage.datas;
    } else {
      this.classBool = "Index";
      localStorage.setItem("datas", "Index");
    }
    localStorage.setItem("datas", this.classBool);
    // });
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        console.log(newVal);
        this.classBool = newVal.name;
        localStorage.setItem("datas", this.classBool);
      }
    }
  }
};
</script>

<style>
.header {
  width: 100%;
  /* border-bottom: 1px solid #41caf9; */
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: white;
  position: absolute;
  top: 0;
  z-index: 9999999;
}
.opc {
  background: rgba(0, 0, 0, 0) !important;
}
.container {
  width: 1200px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin: 0 auto;
  align-items: center;
  height: 70px;
}
.nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.nav li {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  margin-right: 50px;
  /* color: white; */
  padding: 0 5px;
  cursor: pointer;
  /* border-bottom: 2px solid #44E7FD; */
}

.fontWhite {
  color: white !important;
}
.logo {
  margin-right: 100px;
}
.nav .router-link-exact-active {
  border-bottom: 2px solid #44e7fd;
}
.nva2 .router-link-exact-active {
  border-bottom: 2px solid red;
}
.footWrapper {
  width: 1200px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin: 0 auto;
  padding-top: 35px;
  justify-content: space-between;
}
.footContainer {
  background: #3d3e4a;
}
.fotT {
  margin-bottom: 30px;
}
.fotT span {
  font-size: 14px;
  color: white;
}
.fotB span {
  color: #ccc;
  font-size: 12px;
  display: inline-block;
  margin-right: 50px;
}
.footWrapper {
  padding-bottom: 30px;
  border-bottom: 1px solid #64647c;
}
.line {
  width: 1px;
  background: #64647c;
  height: 20px;
  display: inline-block;
  margin: 0 20px;
  margin-bottom: -5px;
}
.footWrpRight {
  width: 120px;
  height: 123px;
  background: #505064;
  margin-top: -30px;
  text-align: center;
  vertical-align: bottom;
  box-sizing: border-box;
  padding-top: 10px;
}
.footLast {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  padding: 20px 0;
}
.wx {
  width: 100px;
  height: 90px;
  background: #d8d8d8;
  margin: 0 auto;
}
.ys li {
  color: white;
}
.nav2 .router-link-exact-active {
  border-bottom: 2px solid #0366f1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue